export default __webpack_public_path__ + "static/media/about-show-pic1.3e6ebf2e.png";